import {Injectable} from "@angular/core";
import {GridLayoutService} from "@irb-common/interfaces/grid-layout.service";
import {DeleteCellComponent} from "@irb-common/components/grid/renderers/delete.cell.component";
import {DeleteHeaderComponent} from "@irb-common/components/grid/renderers/delete.header.component";
import {TruncateTooltipCellComponent} from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';
import {ComScheduledRebalancesListComponent} from "@irb/irb-editors/editor-portfolio/com-scheduled-rebalances-list/com-scheduled-rebalances-list.component";
import {lightningIconCellComponent} from "@irb/irb-editors/rebalance/rebalance-included-portfolio/delete-conditional.cell.component";
import {IUserDetails} from "@irb/app.model";
import { AppService } from "@irb/app.service";

@Injectable({
    providedIn: "root"
})
export class ComScheduledRebalancesListGridLayoutService implements GridLayoutService<ComScheduledRebalancesListComponent> {
    sizeFor: any;
    userDetails = {} as IUserDetails;

    constructor(private as: AppService) {
        this.userDetails = this.as.getItem("IRB_APP_CONFIG") as IUserDetails;
    }

    getFrameworkComponents() {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent,
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent,
            "lightningIconCellComponent": lightningIconCellComponent
        };
    }

    getColumnDefs(parent: ComScheduledRebalancesListComponent) {
        return [{
            headerName: "Delete All",
            headerComponent: "DeleteHeaderComponent",
            headerComponentParams: {
                message: "Remove all from scheduled rebalances?",
                proceed: parent.deleteAll.bind(parent),
                cancel: parent.cancelDelete.bind(parent),
                disableDelete: parent._isUnAuthorized
            },
            cellRendererSelector: (params: any) => {
                const lightningicon = {
                    component: 'lightningIconCellComponent'
                }
                const deleteCellComponent = {
                    component: 'DeleteCellComponent',
                    params: {
                        message: "Remove this from scheduled rebalances?",
                        proceed: parent.delete.bind(parent),
                        cancel: parent.cancelDelete.bind(parent),
                        disableDelete: () => {
                            return !parent._isUnAuthorized
                        }
                    }
                };
                if (params && params.node && params.node.level === 0) {
                    if (params && params.data && params.data.isSmartFiltered)
                        return lightningicon;
                    else
                        return deleteCellComponent;
                }
            },

            resizable: false,
            minWidth: 25,
            maxWidth: 25,
            width: 25,
            cellStyle: (params: any) => {
                if (params && params.data && params.data.isSmartFiltered) {
                    return {'text-align': 'center', 'padding-left': '2px'};
                }
                return null;
            }
        },
            {
                headerName: "Rebalance Name",
                field: "analysisName",
                suppressFiltersToolPanel: true,
                cellRenderer: "cellRendererFormatter",
                cellRendererParams: {
                    link: (params: any) => {
                        let isAnalysisCreatedBy = params.data.analysisCreatedBy === this.userDetails.userID;
                        return (isAnalysisCreatedBy && params.value != null && params.value.length > 0);
                    },
                    onClick: (function (data: any) {
                            parent.showEditRebalance(data);
                    }).bind(parent)
                },
                sort: 'asc',
                flex: 1
            },
            {
                headerName: "Recurs",
                field: "schedulerFrequency",
                suppressFiltersToolPanel: true,
                cellRenderer: 'cellRendererFormatter',
                flex: 1
            },
            {
                headerName: 'Next run date',
                field: 'nextRunDate',
                suppressFiltersToolPanel: true,
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: {
                    type: 'date', format: 'MM/dd/yyyy'
                },
                flex: 1
            }
        ];
    }
}

